import PortalIdParser from 'PortalIdParser';
export const getSelectChannelUrl = inboxId => `/live-messages-settings/${PortalIdParser.get()}/inboxes/${inboxId}/connect-channel`;